import { ImageClusterVariant } from './getHeaderImageClusterVariant';

type Props = {
    isCatalogDone: boolean;
    variant: ImageClusterVariant;
};

export const getHeaderImageClusterContainerClassName = ({ isCatalogDone, variant }: Props): string => {
    const isLive = variant === ImageClusterVariant.Live;
    const isTimedPlusInProgress = variant === ImageClusterVariant.TimedPlusInProgress;

    if (isTimedPlusInProgress) {
        return 'w-full bg-background-critical-light p-sm smMin:rounded-md smMin:w-[416px]';
    }

    if (isLive) {
        return 'bg-background-critical-light smMin:rounded-md smMin:p-sm';
    }

    if (isCatalogDone) {
        return 'px-sm smMin:rounded-md smMin:bg-background-subdued smMin:p-sm';
    }

    return 'px-sm smMin:rounded-md smMin:bg-background-secondary smMin:p-sm';
};
